export default __webpack_public_path__ + "static/media/om-namah-shivaya.7366fc4c.ogg";